/**
 * useCaseSpineStore — revision counter for a case's spine as the Workbench sees it.
 *
 * A promotion (the "Promote to case" control, or the run stream's
 * `spine_promotion` at complete) bumps the revision of that case; the Case
 * wallets panel re-reads GET /canvas/{id}/graph when it changes. Not persisted.
 */
import { create } from 'zustand';

interface CaseSpineState {
    revisions: Record<string, number>;
    bump: (caseId: string) => void;
}

export const useCaseSpineStore = create<CaseSpineState>((set) => ({
    revisions: {},
    bump: (caseId) => set((s) => ({ revisions: { ...s.revisions, [caseId]: (s.revisions[caseId] || 0) + 1 } })),
}));
